import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router';
import { openExternalAppUrl } from '../../apps/myAppsLaunch';
import { useMyAppsStore } from '../../apps/useMyAppsStore';

/** Legacy /apps/link/:slug bookmarks open the URL and leave immediately. */
export function CustomAppLaunchPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const status = useMyAppsStore((s) => s.status);
  const externalApps = useMyAppsStore((s) => s.externalApps);
  const load = useMyAppsStore((s) => s.load);
  const recordRecent = useMyAppsStore((s) => s.recordRecent);
  const openedFor = useRef<string | null>(null);

  useEffect(() => {
    if (status === 'idle' || status === 'error') void load();
  }, [load, status]);

  const app = externalApps.find((item) => item.id.toLowerCase() === (slug ?? '').toLowerCase());

  useEffect(() => {
    if (status !== 'ready') return;
    if (openedFor.current === (slug ?? '')) return;
    openedFor.current = slug ?? '';
    if (app) {
      openExternalAppUrl(app.url);
      void Promise.resolve(recordRecent(app.id)).catch(() => undefined);
    }
    navigate('/', { replace: true });
  }, [app, navigate, recordRecent, slug, status]);

  return null;
}
